/**
 * Generiert eine eindeutige ID für Workflow-Referenzen.
 * Kombiniert Timestamp und zufällige Zeichen.
 * @returns Eine eindeutige ID als String
 */
export const generateUniqueId = (): string => {
  // Aktueller Timestamp (ms seit 1970)
  const timestamp = Date.now().toString(36);
  
  // Zufällige Komponente
  const randomPart = Math.random().toString(36).substring(2, 10);
  
  // Kombiniere für mehr Eindeutigkeit
  return `ref-${timestamp}-${randomPart}`;
};

/**
 * Generiert eine Präfix-basierte Referenz-ID
 * @param prefix Ein optionales Präfix für die ID
 * @param length Die Länge des zufälligen Teils
 * @returns Eine eindeutige ID mit dem angegebenen Präfix
 */
export const generatePrefixedId = (prefix: string = 'ref', length: number = 8): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  
  return `${prefix}-${result}`;
}; 